import { render } from "./ColorWindow.vue?vue&type=template&id=a0f21740&scoped=true"
import script from "./ColorWindow.vue?vue&type=script&lang=js"
export * from "./ColorWindow.vue?vue&type=script&lang=js"

import "./ColorWindow.vue?vue&type=style&index=0&id=a0f21740&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0f21740"]])

export default __exports__